import Rails from '@rails/ujs';

const PODCAST_EPISODE_LOADING_HTML = `
  <div class="d-flex flex-column align-items-center justify-content-center text-center mt-4 p-4 js-podcast-episodes-loading">
    <i class="fa fa-spinner fa-spin fa-2x mb-3" aria-hidden="true"></i>
    <span class="sr-only">Loading episodes...</span>
  </div>
`;

let podcastEpisodeSearchRequestInFlight = false;

function podcastEpisodeListNeedsLoad() {
  const episodeListContainer = document.querySelector('.js-podcast-episodes-list');

  if (!episodeListContainer) { return false }

  return episodeListContainer.dataset.deferLoad === 'true' ||
    !!episodeListContainer.querySelector('.js-podcast-episodes-loading');
}

function submitPodcastEpisodeSearchForm() {
  const podcastEpisodeSearchForm = document.getElementById('show-podcast-filter');
  const episodeListContainer = document.querySelector('.js-podcast-episodes-list');

  if (!podcastEpisodeSearchForm || !episodeListContainer) { return }
  if (podcastEpisodeSearchRequestInFlight) { return }

  const $podcastEpisodeSearchForm = $(podcastEpisodeSearchForm);
  const formAction = $podcastEpisodeSearchForm.attr('action');
  const formData = $podcastEpisodeSearchForm.serialize();

  podcastEpisodeSearchRequestInFlight = true;
  episodeListContainer.innerHTML = PODCAST_EPISODE_LOADING_HTML;
  episodeListContainer.dataset.deferLoad = 'true';
  Rails.fire(podcastEpisodeSearchForm, 'submit');

  history.replaceState(history.state, '', formAction + '?' + formData);
}

function loadDeferredPodcastEpisodes() {
  if (!podcastEpisodeListNeedsLoad()) { return }

  submitPodcastEpisodeSearchForm();
}

window.addEventListener('pageshow', function(event) {
  const navigationEntry = performance.getEntriesByType('navigation')[0];
  const isBackNavigation = event.persisted || navigationEntry?.type === 'back_forward';

  if (!isBackNavigation) { return }

  setTimeout(loadDeferredPodcastEpisodes, 0);
});

document.addEventListener('turbolinks:load', function() {
  const podcastSearchForm = document.getElementById('podcast-filter');
  const podcastEpisodeSearchForm = document.getElementById('show-podcast-filter');

  function podcastEpisodesErrorHtml(message) {
    return `
      <div class="alert alert-danger mt-4" role="alert">
        ${message}
        <div class="mt-2">
          <a href="javascript:void(0)" class="js-retry-podcast-episodes">Try again</a>
        </div>
      </div>
    `;
  }

  function renderPodcastEpisodesError(message = 'There was an error loading episodes. Please try again.') {
    const episodeListContainer = document.querySelector('.js-podcast-episodes-list');

    if (!episodeListContainer) { return }

    episodeListContainer.innerHTML = podcastEpisodesErrorHtml(message);
  }

  function setupPodcastEpisodePagination() {
    const episodeListContainer = document.querySelector('.js-podcast-episodes-list');

    if (!episodeListContainer) { return }

    const viewMoreBtn = episodeListContainer.querySelector('#js-view-more-podcast-episodes-btn');

    if (!viewMoreBtn || viewMoreBtn.dataset.paginationBound === 'true') { return }

    viewMoreBtn.dataset.paginationBound = 'true';
    viewMoreBtn.addEventListener('click', function(event) {
      event.preventDefault();

      const episodesTarget = episodeListContainer.querySelector('.js-infinite-scroll');
      const paginationTarget = episodeListContainer.querySelector('.pagination-link');
      const nextPage = episodeListContainer.querySelector("a[rel='next']");

      if (!episodesTarget || !paginationTarget || !nextPage) { return }

      const currentScrollPosition = window.scrollY;

      viewMoreBtn.disabled = true;
      viewMoreBtn.innerHTML = I18n.t('javascript.infinite_scroll.loading');

      Rails.ajax({
        type: 'GET',
        url: nextPage.href,
        dataType: 'json',
        success: (data) => {
          episodesTarget.insertAdjacentHTML('beforeend', data.entries);
          paginationTarget.innerHTML = data.pagination;

          const navEl = episodeListContainer.querySelector('#nav-container');
          if (navEl) {
            Pagy.init(navEl);
          }

          const updatedNextPage = episodeListContainer.querySelector("a[rel='next']");
          if (updatedNextPage == null) {
            viewMoreBtn.style.display = 'none';
          } else {
            viewMoreBtn.disabled = false;
            viewMoreBtn.innerHTML = 'Click here to see more';
          }

          window.scrollTo(0, currentScrollPosition);
        },
        error: () => {
          viewMoreBtn.disabled = false;
          viewMoreBtn.innerHTML = 'Click here to see more';

          const existingError = episodeListContainer.querySelector('.js-podcast-episodes-pagination-error');
          if (existingError) {
            existingError.remove();
          }

          paginationTarget.insertAdjacentHTML(
            'beforebegin',
            '<div class="alert alert-danger mt-3 js-podcast-episodes-pagination-error" role="alert">There was an error loading more episodes. Please try again.</div>'
          );
        }
      });
    });
  }

  window.setupPodcastEpisodePagination = setupPodcastEpisodePagination;

  if (podcastSearchForm) {

    const $podcastSearchForm = $(podcastSearchForm);
    const formAction = $podcastSearchForm.attr('action');
    const searchInput = document.getElementById('js-search-podcast');
    const dialectsFilter = document.getElementById('js-filter-dialects');
    const levelsFilter = document.getElementById('js-filter-levels');
    const languageFilter = document.getElementById('js-language-select');
    let delayTimer;

    searchInput.addEventListener("input", function(event) {
      clearTimeout(delayTimer);
      delayTimer = setTimeout(function() {
        handleSubmitForm(false);
      }, 1000);
    });

    searchInput.addEventListener("keypress", function(event) {
      if (event.key === 'Enter') {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function() {
          handleSubmitForm(false);
        }, 1000);
      }
    });

    dialectsFilter.addEventListener('change', handleFilterChange);
    levelsFilter.addEventListener('change', handleFilterChange);

    languageFilter.addEventListener('change', function (evt) {
      dialectsFilter.value = undefined;
      levelsFilter.value = undefined;
      handleSubmitForm(true);
    });

    var handleSubmitForm = function(refreshPage) {
      let formData = $podcastSearchForm.serialize();
      if (refreshPage) {
        $podcastSearchForm.submit();
      } else {

        Rails.fire(podcastSearchForm, 'submit');

        let url = formAction + "?" + formData;

        history.replaceState(history.state, "", formAction + "?" + formData);
      }
    }

    function handleFilterChange() {
      searchInput.value = '';

      handleSubmitForm(false);
    }

    $('.js-language-select').on('change', function (evt) {
      handleSubmitForm(true)
    })

    // "Remove filters" clears every filter and reloads. Delegated from the
    // results container rather than bound to the links themselves: the header
    // link and the Featured empty-state link both live inside the partial that
    // index.js.erb replaces on each AJAX filter change, so a direct binding
    // would be lost on re-render (and re-adding it there stacked a fresh
    // handler on every change). One delegated handler survives re-renders and
    // can only ever fire once per click.
    $('.projects-list').on('click', '.js-reset-form', function(e) {
        e.stopPropagation(false);

        $('.js-language-select').val('');
        // Empty array, not undefined: these two are multi-selects and
        // `.val(undefined)` leaves their existing selection in place.
        $('.js-filter-levels').val([]);
        $('.js-filter-dialects').val([]);
        $('.js-search-podcast').val('');

        // The selects are bootstrap-select widgets, so the visible control has
        // to be redrawn after the underlying value changes.
        if ($.fn.selectpicker) {
          $('.js-language-select, .js-filter-levels, .js-filter-dialects').selectpicker('refresh');
        }

        // handleSubmitForm, not `$(form).submit()`. The AJAX filter path runs
        // through Rails.fire; the form has no jQuery submit handler, so
        // triggering submit on it did nothing at all and both links were dead.
        handleSubmitForm(false);
    });

    // if user not logged in display sign up modal after 20 seconds
    let signupLink = document.querySelector('.js-shared-signup-modal-btn');
    let signupModal = document.getElementById('signup-modal');

    if (signupLink) {
      let timerId = setTimeout(function () {
        signupLink.click();
      }, 20000);

      $(signupModal).on('shown.bs.modal', function () {
        clearTimeout(timerId);
      });
    }
  }

  if (podcastEpisodeSearchForm) {
    const $podcastEpisodeSearchForm = $(podcastEpisodeSearchForm);
    const searchInput = document.getElementById('js-search-episodes');
    const episodeListContainer = document.querySelector('.js-podcast-episodes-list');
    let showViewedBtn = document.getElementById('js-show-viewed-episodes');
    let hideViewedBtn = document.getElementById('js-hide-viewed-episodes');
    let sortByCreationDateBtn = document.getElementById('js-sort-by-creation-date');
    let delayTimer;

    searchInput.addEventListener("input", function(event) {
      clearTimeout(delayTimer);
      delayTimer = setTimeout(function() {
        handleSubmitForm();
      }, 1000);
    });

    searchInput.addEventListener("keypress", function(event) {
      if (event.key === 'Enter') {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function() {
          handleSubmitForm();
        }, 1000);
      }
    });

    function handleSubmitForm() {
      submitPodcastEpisodeSearchForm();
    }

    if (hideViewedBtn) {
      hideViewedBtn.addEventListener('change', function (evt) {
        handleSubmitForm()
      })
    }

    if (showViewedBtn) {
      showViewedBtn.addEventListener('change', function (evt) {
        handleSubmitForm()
      })
    }

    if (sortByCreationDateBtn) {
      sortByCreationDateBtn.addEventListener('change', function (evt) {
        handleSubmitForm()
      })
    }

    var resetPodcastEpisodeSearchForm = function() {
      searchInput.value = '';
      if (showViewedBtn) {
        showViewedBtn.checked = false;
      }

      if (hideViewedBtn) {
        hideViewedBtn.checked = false;
      }

      if (sortByCreationDateBtn) {
        sortByCreationDateBtn.checked = false;
      }

      handleSubmitForm();
    }

    $('#js-reset-form').on('click', function(e) {
      e.stopPropagation(false);
      resetPodcastEpisodeSearchForm();
    });

    $podcastEpisodeSearchForm.on('ajax:error', function() {
      renderPodcastEpisodesError();
    });

    $podcastEpisodeSearchForm.on('ajax:complete', function() {
      podcastEpisodeSearchRequestInFlight = false;
    });

    $(document).off('click.podcastEpisodesRetry', '.js-retry-podcast-episodes');
    $(document).on('click.podcastEpisodesRetry', '.js-retry-podcast-episodes', function(e) {
      e.preventDefault();
      handleSubmitForm();
    });

    setupPodcastEpisodePagination();

    loadDeferredPodcastEpisodes();
  }
});
